/**
 *
 * TplMsg
 *
 */

// import React from 'react';
import { message } from "antd"

import { validate } from "../../utils/functions"

const DELAY = 3

const TplMsg = ({ text, type, delay, render }) => {
  if (!validate.exist(text) && !validate.exist(render)) return
  const content = validate.exist(text) ? text : render

  switch (type) {
    case "success":
      message.success(content, DELAY || delay)
      break
    case "error":
      message.error(content, DELAY || delay)
      break
    case "info":
      message.info(content, DELAY || delay)
      break
    case "warning":
      message.warning(content, DELAY || delay)
      break
    case "loading":
      message.loading(text || "Cargando. . . .", 1000000000)
      break
    case "destroy":
      message.destroy()
      break
    default:
      console.log("message")
  }
}

TplMsg.propTypes = {}

export default TplMsg
